import { render, staticRenderFns } from "./ProDialog.vue?vue&type=template&id=edb5cffc&scoped=true"
import script from "./ProDialog.vue?vue&type=script&lang=js"
export * from "./ProDialog.vue?vue&type=script&lang=js"
import style0 from "./ProDialog.vue?vue&type=style&index=0&id=edb5cffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb5cffc",
  null
  
)

export default component.exports